import { Colors } from '@/common/colors/colors';
import Input from '@/common/components/Input';
import CheckBoxInput from '@/common/components/validClaimForm/components/common/checkBoxInput/CheckBoxInput';
import ActionButton from '@/common/components/buttons/ActionButton';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { useRef } from 'react';
import {
	Item,
	ItemsWrapper,
	ListRow,
} from '../../../SerpMonitoring.styles';
import { BLACKLIST_WORD_ALREADY_EXISTS } from '@/common/constants/serpMonitoring';

const StringListField = ({
	title,
	values,
	setValues,
	selectedValues,
	setSelectedValues,
	selectLabel,
}) => {
	const inputRef = useRef();
	const { addMessage } = useMessageQueueContext();

	const handleAdd = (event) => {
		event.preventDefault();
		const nextValue = inputRef.current?.value?.trim();
		if (!nextValue) {
			return;
		}
		const isDuplicate = values.includes(nextValue);
		if (isDuplicate) {
			addMessage(BLACKLIST_WORD_ALREADY_EXISTS, 'error');
			inputRef.current.value = '';
			return;
		}
		setValues([...values, nextValue]);
		inputRef.current.value = '';
	};

	const handleRemove = (removedValue) => {
		setValues(values.filter((value) => value !== removedValue));
		if (setSelectedValues) {
			setSelectedValues(
				selectedValues.filter((value) => value !== removedValue),
			);
		}
	};

	const handleSelect = (toggledValue) => {
		if (selectedValues.includes(toggledValue)) {
			setSelectedValues(
				selectedValues.filter((value) => value !== toggledValue),
			);
			return;
		}
		setSelectedValues([...selectedValues, toggledValue]);
	};

	const renderItem = (value) => (
		<Item key={value} onClick={() => handleRemove(value)}>
			{value}
		</Item>
	);

	return (
		<>
			<ListRow>
				<Input
					color={Colors.darkBlue}
					inputRef={inputRef}
					name={title}
					width={120}
				/>
				<ActionButton defaultText='Add' onClick={handleAdd} />
			</ListRow>
			<ItemsWrapper>
				{values.map((value) =>
					setSelectedValues ? (
						<ListRow key={value}>
							{renderItem(value)}
							<CheckBoxInput
								checked={selectedValues.includes(value)}
								text={selectLabel}
								handleSelect={() => handleSelect(value)}
							/>
						</ListRow>
					) : (
						renderItem(value)
					),
				)}
			</ItemsWrapper>
		</>
	);
};

export default StringListField;
